import { Navigate } from "react-router-dom";
import { getConfigName } from "@helpers/funciones";
import { AvisoDePrivacidadFinbra } from "../components/avisos_de_privacidad/AvisoDePrivacidadFinbra";
import { AvisoDePrivacidadNowPorts } from "../components/avisos_de_privacidad/AvisoDePrivacidadNowPorts";
import { AvisoDePrivacidadAvanzaSolido } from "../components/avisos_de_privacidad/AvisoDePrivacidadAvanzaSolido";
import { AvisoDePrivacidadLendia } from "@components/avisos_de_privacidad/AvisoDePrivacidadLendia";

const domainMap: Record<string, React.FC> = {
  finbra: AvisoDePrivacidadFinbra,
  now_ports: AvisoDePrivacidadNowPorts,
  avanza_solido: AvisoDePrivacidadAvanzaSolido,
};

export const AvisoDePrivacidad = () => {
  const configName = getConfigName(window.location.href);
  const Component = domainMap[configName];

  if (!Component) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Component />
      <AvisoDePrivacidadLendia />
    </>
  );
};
